<field-file {(field)}="image" accept-extentions="png,jpg,jpeg,svg"></field-file>
<a id="genericMobile-image-a" class="image-view {{#unless imgSrc}}hidden{{/unless}}" href="{{imgSrc}}" data-lightbox="genericMobileImage">
    <img src="{{imgSrc}}" class="{{#if imgSrc}}image{{/if}}"/>
</a>
<div cls-action="deleteImage" class="btn icon-left icon-m ui-icon-delete btn-field {{#unless imgSrc}}hidden{{/unless}}">{{msg 'deleteImage'}}</div>